module.exports = __webpack_public_path__ + "footer-icon-lr.png?b8b50a86d60474bbbc8a52b9685bef4c";


//////////////////
// WEBPACK FOOTER
// ./src/Footer/img/base64/footer-icon-lr.png
// module id = 18
// module chunks = 0